import CloseIcon from "@mui/icons-material/CloseRounded";
import { Dialog, DialogContent, DialogTitle, Divider, IconButton } from "@mui/material";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { CurrentTileContextProvider } from "../contexts/CurrentTileContextProvider";
import { useDashboardContext } from "../contexts/DashboardContext";
import { canEditWidget, canMaximizeWidget } from "../utils/widgetVisibility";
import TileHeader from "./TileHeader";
import WidgetRenderer from "./WidgetRenderer";

function TileViewOverlay() {
  const navigate = useNavigate();
  const { widgetId } = useParams();
  const { tileObjects } = useDashboardContext();
  const tile = tileObjects.find((t) => t.id === widgetId);

  useEffect(() => {
    if (!tile) {
      navigate("..");
    }
  }, [tile, navigate]);

  if (!tile) {
    return null;
  }

  return (
    <Dialog open={true} fullScreen sx={{ m: 2 }} slotProps={{ paper: { sx: { borderRadius: 1 } } }}>
      <DialogTitle sx={{ p: 2, display: "flex" }}>
        <TileHeader
          tile={tile.item}
          hover={true}
          menuPlacement="inline"
          shouldShowMaximize={canMaximizeWidget}
          shouldShowEdit={canEditWidget}
        />
        <IconButton onClick={() => navigate(`..`)}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ position: "relative", overflow: "hidden" }}>
        <CurrentTileContextProvider tile={tile}>
          <WidgetRenderer widget={tile.item.widget} />
        </CurrentTileContextProvider>
      </DialogContent>
    </Dialog>
  );
}

export default TileViewOverlay;
